import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: '/file',
        name: 'FileManager',
        component: () => import('@/views/FileManager.vue')
      },
      {
        path: '/user/management',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue')
      },
      {
        path: '/role',
        name: 'RoleManagement',
        component: () => import('@/views/RoleManagement.vue')
      },
      {
        path: '/menu',
        name: 'MenuManagement',
        component: () => import('@/views/MenuManagement.vue')
      },
      {
        path: '/permission/organization',
        name: 'OrganizationManagement',
        component: () => import('@/views/OrganizationManagement.vue')
      },
      {
        path: '/permission/channel',
        name: 'ChannelManagement',
        component: () => import('@/views/ChannelManagement.vue')
      },
      {
        path: '/permission/lender',
        name: 'LenderManagement',
        component: () => import('@/views/LenderManagement.vue')
      },
      {
        path: '/permission/loanPrice',
        name: 'LoanPriceManagement',
        component: () => import('@/views/LoanPriceManagement.vue')
      },
      {
        path: '/permission/product',
        name: 'ProductManagement',
        component: () => import('@/views/ProductManagement.vue')
      },
      {
        path: '/apply/pending',
        name: 'ApplyPending',
        component: () => import('@/views/ApplyPending.vue')
      },
      {
        path: '/apply/processed',
        name: 'ApplyProcessed',
        component: () => import('@/views/ApplyProcessed.vue')
      },
      {
        path: '/apply/query',
        name: 'ApplyQuery',
        component: () => import('@/views/ApplyQuery.vue')
      },
      {
        path: '/apply/supplement/pending',
        name: 'ApplySupplementPending',
        component: () => import('@/views/ApplySupplementPending.vue')
      },
      {
        path: '/apply/supplement/processed',
        name: 'ApplySupplementProcessed',
        component: () => import('@/views/ApplySupplementProcessed.vue')
      },
     /* {
        path: '/apply/supplement/process',
        name: 'ApplySupplementProcess',
        component: () => import('@/views/ApplySupplement.vue')
      },
      {
        path: '/apply/supplement/detail',
        name: 'ApplySupplementDetail',
        component: () => import('@/views/ApplySupplement.vue')
      },
      {
        path: '/apply/supplement/readonly',
        name: 'ApplySupplementReadOnly',
        component: () => import('@/views/ApplySupplementReadOnly.vue')
      },*/
      {
        path: '/apply/audit',
        name: 'ApplyAudit',
        component: () => import('@/views/ApplyAudit.vue')
      },
      {
        path: '/apply/audit/processed',
        name: 'ApplyAuditProcessed',
        component: () => import('@/views/ApplyAuditProcessed.vue')
      },
      /*{
        path: '/apply/audit/detail',
        name: 'ApplyAuditDetail',
        component: () => import('@/views/ApplyAuditDetail.vue')
      },
      {
        path: '/apply/detail',
        name: 'ApplyDetail',
        component: () => import('@/views/ApplyDetail.vue')
      },*/
      {
        path: '/order/disbursement-entry',
        name: 'DisbursementEntry',
        component: () => import('@/views/DisbursementEntry.vue')
      },
      {
        path: '/order/disbursement-entry/processed',
        name: 'DisbursementEntryProcessed',
        component: () => import('@/views/DisbursementEntryProcessed.vue')
      },
      /*{
        path: '/order/disbursement-entry/detail',
        name: 'DisbursementEntryDetail',
        component: () => import('@/views/DisbursementEntryDetail.vue')
      },*/
      {
        path: '/order/disbursement-audit',
        name: 'DisbursementAudit',
        component: () => import('@/views/DisbursementAudit.vue')
      },
      {
        path: '/order/disbursement-audit/processed',
        name: 'DisbursementAuditProcessed',
        component: () => import('@/views/DisbursementAuditProcessed.vue')
      },
      {
        path: '/order/disbursement-payment',
        name: 'DisbursementPayment',
        component: () => import('@/views/DisbursementPaymentProcess.vue')
      },
      {
        path: '/order/disbursement-payment/processed',
        name: 'DisbursementPaymentProcessed',
        component: () => import('@/views/DisbursementPaymentProcessed.vue')
      },
      {
        path: '/order/receipt',
        name: 'ReceiptManagement',
        component: () => import('@/views/ReceiptManagement.vue')
      },
      {
        path: '/postLoan/customerFollow',
        name: 'PostLoanCustomerFollow',
        component: () => import('@/views/PostLoanCustomerFollow.vue')
      },
      {
        path: '/postLoan/customerFollowQuery',
        name: 'PostLoanCustomerFollowQuery',
        component: () => import('@/views/PostLoanCustomerFollowQuery.vue')
      },
      {
        path: '/postLoan/overdueTransfer',
        name: 'OverdueTransfer',
        component: () => import('@/views/OverdueTransfer.vue')
      },
      {
        path: '/postLoan/repayment/pending',
        name: 'RepaymentPending',
        component: () => import('@/views/Repayment.vue')
      },
      {
        path: '/postLoan/repayment/dhg',
        name: 'RepaymentDHG',
        component: () => import('@/views/Repayment.vue')
      },
      {
        path: '/postLoan/repayment/cw',
        name: 'RepaymentCW',
        component: () => import('@/views/Repayment.vue')
      },
      {
        path: '/postLoan/repayment/processed',
        name: 'RepaymentProcessed',
        component: () => import('@/views/Repayment.vue')
      },
      {
        path: '/postLoan/feeSharing',
        name: 'FeeSharing',
        component: () => import('@/views/FeeSharing.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决导航重复报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

router.beforeEach(async (to, from, next) => {
  const token = getToken()

  // 如果访问根路径，跳转到登录页
  if (to.path === '/') {
    if (!token) {
      next('/login')
      return
    }
    next()
    return
  }

  // 如果访问登录页
  if (to.path === '/login') {
    // 如果已登录，跳转到dashboard
    if (token) {
      next('/dashboard')
      return
    }
    // 未登录，继续访问登录页
    next()
    return
  }

  // 如果路由需要认证但没有 token,跳转到登录页
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }

  // 如果有token但还没有用户信息，获取用户信息和权限
  if (token && to.meta.requiresAuth) {
    try {
      await store.dispatch('user/getUserInfo')
    } catch (error) {
      // 获取用户信息失败，token可能失效，清除token并跳转登录页
      removeToken()
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      } else {
        next()
      }
      return
    }
  }

  next()
})

export default router